import { MERGE_LORD_AVATAR_DATA_URI } from './mergeLordAvatar';

/**
 * Per-character sidebar crest avatars, keyed by character id. Each value is a
 * self-contained `data:` URI (an `<img src>`, so fixed colors — see
 * `mergeLordAvatar.ts`). Add an entry here when a new character ships a crest.
 *
 * The sidebar shows the first held character that has an entry here; the
 * greeting-header badges still enumerate ALL of a user's characters.
 */
export const CHARACTER_AVATARS: Record<string, string> = {
  'merge-lord': MERGE_LORD_AVATAR_DATA_URI,
};

/** The crest data-URI for a character id, or undefined if it has none. */
export function characterAvatar(id: string): string | undefined {
  return CHARACTER_AVATARS[id];
}
